<template>
  <div class="ContentLoader-container">
    <img class="ContentLoader" src="@/assets/images/loading.gif">
  </div>
</template>
<script>


export default {
  name: 'ContentLoader',
};

</script>
<style lang="scss" scoped>
  @keyframes loader-intro {
    from {
      opacity: 0;
      transform: scale(0.8);
    }

    to {
      opacity: 1;
      transform: scale(1);
    }
  }

  .ContentLoader-container {
    pointer-events: none;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 100px;

    .ContentLoader {
      width: 3em;
      animation-name: loader-intro;
      animation-iteration-count: 1;
      animation-duration: 1s;
      animation-fill-mode: both;
    }
  }
</style>
